export * from './activityRest.service';
import { ActivityRestService } from './activityRest.service';
export * from './configValueRest.service';
import { ConfigValueRestService } from './configValueRest.service';
export * from './coverageMapRest.service';
import { CoverageMapRestService } from './coverageMapRest.service';
export * from './dataRest.service';
import { DataRestService } from './dataRest.service';
export * from './deadlineRest.service';
import { DeadlineRestService } from './deadlineRest.service';
export * from './employeeRest.service';
import { EmployeeRestService } from './employeeRest.service';
export * from './enterpriseRest.service';
import { EnterpriseRestService } from './enterpriseRest.service';
export * from './eventRest.service';
import { EventRestService } from './eventRest.service';
export * from './exaAdapterRest.service';
import { ExaAdapterRestService } from './exaAdapterRest.service';
export * from './exaBeaconRest.service';
import { ExaBeaconRestService } from './exaBeaconRest.service';
export * from './externalAccessRest.service';
import { ExternalAccessRestService } from './externalAccessRest.service';
export * from './fieldRest.service';
import { FieldRestService } from './fieldRest.service';
export * from './fileRest.service';
import { FileRestService } from './fileRest.service';
export * from './implementRest.service';
import { ImplementRestService } from './implementRest.service';
export * from './interpolationMapRest.service';
import { InterpolationMapRestService } from './interpolationMapRest.service';
export * from './isoTaskDataRest.service';
import { IsoTaskDataRestService } from './isoTaskDataRest.service';
export * from './jobRest.service';
import { JobRestService } from './jobRest.service';
export * from './locationRest.service';
import { LocationRestService } from './locationRest.service';
export * from './machineRest.service';
import { MachineRestService } from './machineRest.service';
export * from './operationRest.service';
import { OperationRestService } from './operationRest.service';
export * from './partnerRest.service';
import { PartnerRestService } from './partnerRest.service';
export * from './planningRest.service';
import { PlanningRestService } from './planningRest.service';
export * from './rawDataRest.service';
import { RawDataRestService } from './rawDataRest.service';
export * from './retailerRest.service';
import { RetailerRestService } from './retailerRest.service';
export * from './statisticsRest.service';
import { StatisticsRestService } from './statisticsRest.service';
export * from './taskRest.service';
import { TaskRestService } from './taskRest.service';
export * from './userRest.service';
import { UserRestService } from './userRest.service';
export * from './workingtimeRawDataRest.service';
import { WorkingtimeRawDataRestService } from './workingtimeRawDataRest.service';
export * from './workingtimeRest.service';
import { WorkingtimeRestService } from './workingtimeRest.service';
export const APIS = [
  ActivityRestService,
  ConfigValueRestService,
  CoverageMapRestService,
  DataRestService,
  DeadlineRestService,
  EmployeeRestService,
  EnterpriseRestService,
  EventRestService,
  ExaAdapterRestService,
  ExaBeaconRestService,
  ExternalAccessRestService,
  FieldRestService,
  FileRestService,
  ImplementRestService,
  InterpolationMapRestService,
  IsoTaskDataRestService,
  JobRestService,
  LocationRestService,
  MachineRestService,
  OperationRestService,
  PartnerRestService,
  PlanningRestService,
  RawDataRestService,
  RetailerRestService,
  StatisticsRestService,
  TaskRestService,
  UserRestService,
  WorkingtimeRawDataRestService,
  WorkingtimeRestService,
];
